import { Helmet } from "react-helmet-async";
import ImageSlider from "./ImageSlider.jsx";


const Home = () => {
  return (
    <div id="home" className="flex flex-col text-center py-0 w-screen bg-gray-100">
      <Helmet>
        <title>Dr. Srikanth Urology Clinic - Best Urologist in Bengaluru</title>
        <meta
          name="description"
          content="Dr. Srikanth - Experienced urologist in Bengaluru offering expert kidney and urological care. Book an appointment today!"
        />
        <meta
          name="keywords"
          content="Dr. Srikanth, Urologist in Bengaluru, Kidney Specialist, Urology Clinic, Best Urologist"
        />
      </Helmet>

      <div className="w-full">
        <h1 className="sr-only">Dr. Srikanth - Best Urologist in Bengaluru</h1>
        <h2 className="sr-only">Expert Urological Care for Kidney Stones, Prostate Health, and Urinary Disorders</h2>
        <h3 className="sr-only">Book an Appointment with Dr. Srikanth for the Best Urology Treatment</h3>

        <ImageSlider aria-label="Image slider showcasing Dr. Srikanth's Urology Clinic" />
      </div>
    </div>
  );
};

export default Home;
